import React, {useState} from 'react';
import ReactDOM from 'react-dom/client';
import { useNavigate, Navigate }  from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStore } from '../stores/Store';



const AdminRouter = observer(({children}) => {
    const store = useStore();

    let { isLoggedIn } = store;
    let { user } = store;
    

    return (isLoggedIn && user.role !== '5d8e0b079f51d42bbece9201') ? children : <Navigate to='/signin'/>
    
})

export default AdminRouter
